<template>
<div></div>
</template>
<script>
    import $ from '../../assets/js/jquery.min.js'
    export default{
    name:'slide',
    }
    // $(function(){
    //     $(".indexs").css({ left: (document.body.clientWidth - $(".categroy_main_c.clearfix").eq(0).width()) / 2 - 60 });
    //     let scrollTop = 0

	// let section = document.querySelector('.categroy_centers')

	// let sectionLi = document.querySelectorAll('.categroy_centers .categroy_center2')

	// let indexs = document.querySelector('.indexs')

	// let indexsLi = document.querySelectorAll('.indexs li')

	// let ofseTop = 0

	// let requestId = null

	// let recordScrollTop = 0
	// // 页面滚动方向
	// let scrollDirection = null
	// let diffX = 0
	// let diffY = 0
	// let scrollAction = { x: 'undefined', y: 'undefined' }
	// let lastI = 0
	// let direction = null

	// window.onscroll = myScroll
	// function myScroll(e) {

	// 	scrollTop = document.body.scrollTop || document.documentElement.scrollTop

		// 当header滚出去时出现左侧导航
		
		// if (section.offsetTop - scrollTop <= 120) {
		// 	indexs.classList.add('active')
        //     indexs.style.display='block'
		// } else if(section.offsetTop - scrollTop > 120) {
		// 	indexs.classList.remove('active')
        //     indexs.style.display='none'
		// }
		// 滚到sectionLi对应的li时候 给indexs对应的li红色高亮
		// for (let i = 0; i < sectionLi.length; i++) {

		// 	if (sectionLi[i].offsetTop - scrollTop <= 80) {
		// 		for (let j = 0; j < indexsLi.length; j++) {
		// 			indexsLi[j].classList.remove('addcolor')
		// 		}
		// 		indexsLi[i].classList.add('addcolor')
		// 	}

		// }

	// }
	// 点击indexs对应的li 页面滚回到section对应的li
	// for (let i = 0; i < indexsLi.length; i++) {
	// 	indexsLi[i].addEventListener('click', function (e) {

	// 		for (let j = 0; j < indexsLi.length; j++) {
	// 			indexsLi[j].classList.remove('active')
	// 		}
	// 		// i就是被点击的那个li的索引值
	// 		indexsLi[i].classList.add('active')

	// 		// 记录下被点击的li的offsetTop
	// 		ofseTop = sectionLi[i].offsetTop - 50

			// 第一种方法 jquery 动画 这里不用jquery 用requestAnimationFrame
			// $('html,body').animate({
			//     scrollTop: ofseTop
			// }, 300)

			// 第二种方法 requestAnimationFrame
	// 		if (i - lastI > 0) {
	// 			direction = 'down'
	// 		} else if (i - lastI < 0) {
	// 			direction = 'up'
	// 		}
	// 		// 更新lastI
	// 		lastI = i

	// 		// 记录点击li的时候 当前页面卷出去了多少
	// 		recordScrollTop = document.body.scrollTop || document.documentElement.scrollTop
	// 		requestId = requestAnimationFrame(scrollAnimate)
	// 	})
	// }



	// function scrollAnimate() {
	// 	// 滚动条向下滚动 页面向上翻 当前页面卷出去更多
	// 	if (direction && direction === 'down') {
	// 		recordScrollTop += 30
	// 		if (recordScrollTop >= ofseTop) {
	// 			direction = null
	// 			return cancelAnimationFrame(requestId)
	// 		}

	// 	}
	// 	// 滚动条向上滚动 页面向下翻 当前页面卷出去更少
	// 	if (direction && direction === 'up') {
	// 		recordScrollTop -= 30
	// 		if (recordScrollTop <= ofseTop) {
	// 			direction = null
	// 			return cancelAnimationFrame(requestId)
	// 		}
	// 	}


	// 	document.body.scrollTop = recordScrollTop

	// 	document.documentElement.scrollTop = recordScrollTop
	// 	requestId = requestAnimationFrame(scrollAnimate)

	// }

// 	function navList(id) {
//     var $obj = $("#J_navlist")
//     $obj.find("h4").hover(function () {
//         $(this).addClass("hover");
//     }, function () {
//         $(this).removeClass("hover");
//     });
//     $obj.find("p").hover(function () {
//         if ($(this).hasClass("on")) { return; }
//         $(this).addClass("hover");
//     }, function () {
//         if ($(this).hasClass("on")) { return; }
//         $(this).removeClass("hover");
//     });
//     $obj.find("h4").click(function () {
//         var $div = $(this).siblings(".list-item");
//         if ($(this).parent().hasClass("selected")) {
//             $div.slideUp(600);
//             $(this).parent().removeClass("selected");
//         }
//         if ($div.is(":hidden")) {
//             $("#J_navlist li").find(".list-item").slideUp(600);
//             $("#J_navlist li").removeClass("selected");
//             $(this).parent().addClass("selected");
//             $div.slideDown(600);

//         } else {
//             $div.slideUp(600);
//         }
//     });
// }
// })
</script>
